/* global axios */
import ApiClient from './ApiClient';

// API client for AI Agents (account-level, for automation rules)
class AiAgentsAPI extends ApiClient {
  constructor() {
    super('ai_agents', { accountScoped: true });
  }

  // Get list of AI agents available for automation
  // Returns: [{id: 1, name: 'Agent Name'}, ...]
  getAll() {
    return axios.get(this.url);
  }
}

export default new AiAgentsAPI();
